import React, { createContext, useContext } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {

    const appType = () => {
        if(window.isApp) {
            const userAgent = navigator.userAgent;
            if(/android/i.test(userAgent)) {
                return 'android';
            }
            if(/iPad|iPhone|iPod/i.test(userAgent)) {
                return 'ios';
            }
            if(/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
                return 'ios';
            }
        }
        return 'desktop';
    };

    const appSendMessage = (command,data) => {
        var json 		= {};
        json.command 	= command;
        json.data 		= data;

        console.log("appSendMessage: "+appType()+" command: "+command);

        if(appType()==="ios") {
            if(window.webkit!==undefined) {
                window.webkit.messageHandlers.appSendMessage.postMessage(JSON.stringify(json));
            }
        } else 
        if(appType()==='android') {
            if(window.Android!==undefined) {
                window.Android.appSendMessage(JSON.stringify(json));
            }
        } else {
            if(command==='openURL') {
                window.open(data);
            }
        }
    };
    
    return (
        <AppContext.Provider value={{ appSendMessage, appType }}>
            {children}
        </AppContext.Provider>
    );
};

export const useApp = () => useContext(AppContext);